import { ReportDTO, OrderResult } from './orderResult';

export class DetailedResultDto {
  testCode: string;
  orderResult: OrderResult;
  patientData: PatientDetailed;
  markerRiskDto: MarkerRiskDto;
  reports: ReportDTO[];
}
export class PatientDetailed {
  ageEDD: string;
  GAUSDate: string;
  GADrawDate: string;
}

export class MarkerRiskDto {
  accessionId: string;
  errorText: string;
  bu: string;
  markers: Marker[];
  risks: Risk[];
}
export class Marker {
  markerName: string;
  value: string;
  moM: number;
  percentile: number;
}

export class Risk {
  riskName: string;
  cutOff: string;
  riskBeforeScreening: string;
  riskAfterScreening: string;
  result: string;
}
